/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Settings} from '../models/Settings';

export interface CrmIntegration$Request {
    accountId: number;
    crmIntegration: boolean;
}

export interface CrmIntegration$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const crmIntegrationRequest = createAction<PayloadData<void, CrmIntegration$Request>>('SETTINGS_CONTROLLER__CRM_INTEGRATION__REQUEST');
export const crmIntegrationSuccess = createAction<PayloadData<void, CrmIntegration$Request>>('SETTINGS_CONTROLLER__CRM_INTEGRATION__SUCCESS');
export const crmIntegrationFailure = createAction<PayloadData<Error, CrmIntegration$Request, true>>('SETTINGS_CONTROLLER__CRM_INTEGRATION__FAILURE');

export const crmIntegrationActions = [
    crmIntegrationRequest,
    crmIntegrationSuccess,
    crmIntegrationFailure
] as const;

/**
 * Crm Integration
 * @param {number} meta.accountId Account id
 * @param {boolean} meta.crmIntegration enable/disable CRM Integration
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const crmIntegration = (meta: CrmIntegration$Request, config?: CrmIntegration$Config) => {
    const TRANSPORT_GET_PARAMS = {
        crmIntegration: meta.crmIntegration,
    };
    return {
        CALL_API: {
            types: crmIntegrationActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings/crm-integration`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface Enabled$Request {
    accountId: number;
    enabled: boolean;
}

export interface Enabled$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const enabledRequest = createAction<PayloadData<void, Enabled$Request>>('SETTINGS_CONTROLLER__ENABLED__REQUEST');
export const enabledSuccess = createAction<PayloadData<void, Enabled$Request>>('SETTINGS_CONTROLLER__ENABLED__SUCCESS');
export const enabledFailure = createAction<PayloadData<Error, Enabled$Request, true>>('SETTINGS_CONTROLLER__ENABLED__FAILURE');

export const enabledActions = [
    enabledRequest,
    enabledSuccess,
    enabledFailure
] as const;

/**
 * Enabling settings
 * @param {number} meta.accountId Account id
 * @param {boolean} meta.enabled Toggle switcher
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const enabled = (meta: Enabled$Request, config?: Enabled$Config) => {
    const TRANSPORT_GET_PARAMS = {
        enabled: meta.enabled,
    };
    return {
        CALL_API: {
            types: enabledActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings/enabled`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface FullAccess$Request {
    accountId: number;
    fullAccess: boolean;
}

export interface FullAccess$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const fullAccessRequest = createAction<PayloadData<void, FullAccess$Request>>('SETTINGS_CONTROLLER__FULL_ACCESS__REQUEST');
export const fullAccessSuccess = createAction<PayloadData<void, FullAccess$Request>>('SETTINGS_CONTROLLER__FULL_ACCESS__SUCCESS');
export const fullAccessFailure = createAction<PayloadData<Error, FullAccess$Request, true>>('SETTINGS_CONTROLLER__FULL_ACCESS__FAILURE');

export const fullAccessActions = [
    fullAccessRequest,
    fullAccessSuccess,
    fullAccessFailure
] as const;

/**
 * Full Access
 * @param {number} meta.accountId Platform account id
 * @param {boolean} meta.fullAccess Full Access switcher
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const fullAccess = (meta: FullAccess$Request, config?: FullAccess$Config) => {
    const TRANSPORT_GET_PARAMS = {
        fullAccess: meta.fullAccess,
    };
    return {
        CALL_API: {
            types: fullAccessActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings/full-access`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSettings$Request {
    accountId: number;
}

export interface GetSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSettingsRequest = createAction<PayloadData<void, GetSettings$Request>>('SETTINGS_CONTROLLER__GET_SETTINGS__REQUEST');
export const getSettingsSuccess = createAction<PayloadData<Settings, GetSettings$Request>>('SETTINGS_CONTROLLER__GET_SETTINGS__SUCCESS');
export const getSettingsFailure = createAction<PayloadData<Error, GetSettings$Request, true>>('SETTINGS_CONTROLLER__GET_SETTINGS__FAILURE');

export const getSettingsActions = [
    getSettingsRequest,
    getSettingsSuccess,
    getSettingsFailure
] as const;

/**
 * Fetch settings
 * @param {number} meta.accountId Platform account id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSettings = (meta: GetSettings$Request, config?: GetSettings$Config) => {
    return {
        CALL_API: {
            types: getSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UntrackedEvents$Request {
    accountId: number;
    untrackedEvents: boolean;
}

export interface UntrackedEvents$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const untrackedEventsRequest = createAction<PayloadData<void, UntrackedEvents$Request>>('SETTINGS_CONTROLLER__UNTRACKED_EVENTS__REQUEST');
export const untrackedEventsSuccess = createAction<PayloadData<void, UntrackedEvents$Request>>('SETTINGS_CONTROLLER__UNTRACKED_EVENTS__SUCCESS');
export const untrackedEventsFailure = createAction<PayloadData<Error, UntrackedEvents$Request, true>>('SETTINGS_CONTROLLER__UNTRACKED_EVENTS__FAILURE');

export const untrackedEventsActions = [
    untrackedEventsRequest,
    untrackedEventsSuccess,
    untrackedEventsFailure
] as const;

/**
 * Untracked Events
 * @param {number} meta.accountId Account id
 * @param {boolean} meta.untrackedEvents Exclude/Include account from the usage data tracking
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const untrackedEvents = (meta: UntrackedEvents$Request, config?: UntrackedEvents$Config) => {
    const TRANSPORT_GET_PARAMS = {
        untrackedEvents: meta.untrackedEvents,
    };
    return {
        CALL_API: {
            types: untrackedEventsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/api-v2/${meta.accountId}/settings/untracked-events`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

